export default __webpack_public_path__ + "static/program-circle-repaired-pl-1363b2a89aa9c824e2f82d61491ce594.svg";